import moment from 'moment-timezone';
import { DEFAULT_TIMEZONE } from 'util/dateAndTime';

export const formatDate = (dateInUnix: number): string => {
  return moment(dateInUnix).tz(DEFAULT_TIMEZONE).format('ll');
};
